// extracted by mini-css-extract-plugin
module.exports =  {"buttons":"buttons__OABLu","right":"right__07C24"};